import { ExpandLess, ExpandMore, Sort } from "@mui/icons-material"
import { Box, Collapse } from "@mui/material"
import { useState } from "react"
import { Button } from "src/lib"
import intl from "src/internationalization/intl"
import { AdvisorRankingsPreview } from "./AdvisorRankingsPreview"

const AdvisorRankingsCollapsible = () => {
    const [open, setOpen] = useState(false)
    const [hasOpened, setHasOpened] = useState(false)

    const handleToggle = () => {
        setOpen((prev) => {
            if (!prev) setHasOpened(true)
            return !prev
        })
    }

    return (
        <Box sx={{ width: "100%", mb: 1 }}>
            <Button
                variant="text"
                color="primary"
                size="small"
                startIcon={<Sort sx={{ fontSize: 18 }} />}
                endIcon={open ? <ExpandLess sx={{ fontSize: 20 }} /> : <ExpandMore sx={{ fontSize: 20 }} />}
                onClick={handleToggle}
                sx={{
                    minHeight: 28,
                    px: 0.5,
                    py: 0,
                    fontSize: "0.8125rem",
                    fontWeight: 600,
                    textTransform: "none",
                    "& .MuiButton-startIcon": { mr: 0.5 },
                    "& .MuiButton-endIcon": { ml: 0.25 },
                }}
            >
                {open ? intl("rankingPreviewHide") : intl("rankingPreviewShow")}
            </Button>

            <Collapse in={open} timeout="auto" unmountOnExit={false}>
                {hasOpened ? <AdvisorRankingsPreview /> : null}
            </Collapse>
        </Box>
    )
}

export { AdvisorRankingsCollapsible }
